import lf from 'lovefield'

export function aleas (schemaBuilder) {
  schemaBuilder.createTable('aleas')
  		.addColumn('id', lf.Type.INTEGER)
      .addColumn('alea_group_id', lf.Type.INTEGER)
      .addColumn('alea_id', lf.Type.INTEGER)
      .addColumn('champ_application_related_id', lf.Type.INTEGER)
      .addColumn('date_debut', lf.Type.DATE_TIME)
      .addColumn('date_debut_jour', lf.Type.INTEGER)
      .addColumn('date_fin', lf.Type.DATE_TIME)
      .addColumn('date_fin_jour', lf.Type.INTEGER)
      .addColumn('cout', lf.Type.INTEGER)
      .addColumn('description', lf.Type.STRING)
      .addColumn('valeur_specifique', lf.Type.INTEGER)
      .addColumn('valeur_specifique_libelle', lf.Type.STRING)
      .addColumn('alea_name', lf.Type.STRING)
      .addColumn('category_name', lf.Type.STRING)
      .addColumn('champ_application_name', lf.Type.STRING)
      .addPrimaryKey(['id'])
      //.addNullable(['valeur_specifique_libelle', 'champ_application_name', 'category_name', 'valeur_specifique', 'cout']);
}

/*
CREATE TABLE IF NOT EXISTS `const-cubaturestypes` (
  `code` varchar(3) NOT NULL,
  `nom` varchar(20) NOT NULL,
  PRIMARY KEY (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/aleas.schema.js